import { render, staticRenderFns } from "./wert.vue?vue&type=template&id=560808f9&"
import script from "./wert.vue?vue&type=script&lang=js&"
export * from "./wert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports